<template>
    <button class="EditIconButton">
        <svg-view name="edit"></svg-view>
    </button>
</template>

<script>
export default {
    name: "EditIconButton",
};
</script>

<style scoped lang="less">
    @import "~styles/const.less";

    .EditIconButton {
        position: relative;
        display: block;
        width: 56px;
        height: 56px;
        background: var(--button-bg-color);
        backdrop-filter: blur(27.1828px);
        border-radius: 50%;
        transition: 0.2s background;
        cursor: pointer;

        &:hover {
            background: var(--button-bg-hover-color);

            svg {
                fill: var(--button-icon-hover-color);
            }
        }

        svg {
            position: absolute;
            top: 17px;
            left: 17px;
            width: 22px;
            height: 22px;
            fill: var(--button-icon-color);
            transition: 0.2s fill;
        }
    }
</style>